import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';

import { getIsTariffAccumsFttbDivideEnabled } from 'utils/getIsTariffAccumsFttbDivideEnabled';

import type { HomeServicesType } from './types';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const HomeServices: FC<HomeServicesType> = ({ items, isMobile }) => {
  const isMobileDimention = useIsMobileDimension();

  return (
    <div className={cn('container')}>
      {items.map((item) => (
        <div className={cn('item')} key={item.value}>
          {!getIsTariffAccumsFttbDivideEnabled() && (
            <img alt="icon" className={cn('icon')} src={item.iconSrc} />
          )}
          <Text variant={isMobile || isMobileDimention ? 'caption-medium' : 'body-paragraph-small'}>
            {item.value}
          </Text>
          <Text variant={isMobile || isMobileDimention ? 'caption-medium' : 'body-paragraph-small'}>
            {item.unit.toLocaleLowerCase()}
          </Text>
        </div>
      ))}
    </div>
  );
};
